import { render, staticRenderFns } from "./CriarImplantacao.vue?vue&type=template&id=5074b38e&scoped=true&"
import script from "./CriarImplantacao.vue?vue&type=script&lang=js&"
export * from "./CriarImplantacao.vue?vue&type=script&lang=js&"
import style0 from "./CriarImplantacao.vue?vue&type=style&index=0&id=5074b38e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074b38e",
  null
  
)

export default component.exports